import ACTIONS from '~shared/actions';
import { Grow2384Actions, Grow2384StateType } from './types';

export const grow2384State: Grow2384StateType = {
  responseToggleChecked: false,
};

export default function Grow2384Reducer(state: Grow2384StateType, action: Grow2384Actions): Grow2384StateType {
  const { type, payload } = action;

  if (type === ACTIONS.TOGGLE_SWITCH) {
    return {
      ...state,
      responseToggleChecked: payload.responseToggleChecked,
    };
  }

  return state;
}
